// extracted by css-extract-rspack-plugin
export default {"labelRequiredStar":"fzrd4B","labelText":"F8MI4P","labelContainer":"ZD6j7M","labelWrapper":"nRLIf7"};